import { useTranslation } from '@mc/i18n'
import { Button, IconChevronLeftDefault } from '@mc/design-system'
import { usePrimaryCta } from '@mc/growth'
import { trackPurchaseClick } from '@mc/pre-paywall-events'
import { getPageSource } from '@mc/track-event'

import { CONCIERGE_EXPERIENCE_I18N_NAMESPACE } from '../i18n/i18nInstance'
import { useFab } from './FabProvider'
import { trackConciergeClicked } from '../events'

export const ExplainerScreen = () => {
  const { t } = useTranslation(CONCIERGE_EXPERIENCE_I18N_NAMESPACE)

  const { changeView } = useFab()
  const { ctaHref } = usePrimaryCta()

  const handleBackClick = () => {
    trackConciergeClicked({ level: 'secondary', action: 'back' })
    changeView('content')
  }

  return (
    <>
      <Button kind='link' className='mc-p-0' onClick={handleBackClick}>
        <IconChevronLeftDefault size='lg' />
      </Button>

      <p className='d-none d-md-block mc-text-h5 mc-my-4'>
        {t('fab.explainer.title')}
      </p>
      <p className='d-block d-md-none mc-text-h6 mc-my-4'>
        {t('fab.explainer.title')}
      </p>

      <ExplainerOption
        title={t('fab.explainer.option1.title')}
        description={t('fab.explainer.option1.description')}
      />
      <ExplainerOption
        title={t('fab.explainer.option2.title')}
        description={t('fab.explainer.option2.description')}
      />
      <ExplainerOption
        title={t('fab.explainer.option3.title')}
        description={t('fab.explainer.option3.description')}
      />

      <Button
        kind='tertiary'
        fullWidth
        as='a'
        href={ctaHref}
        onClick={() => {
          trackConciergeClicked({
            level: 'secondary',
            action: t('fab.explainer.cta'),
          })
          trackPurchaseClick({
            action: t('fab.explainer.cta'),
            href: ctaHref,
            location: 'concierge',
            pageSource: getPageSource(),
          })
        }}
      >
        {t('fab.explainer.cta')}
      </Button>
    </>
  )
}

const ExplainerOption = ({
  title,
  description,
}: {
  title: string
  description: string
}) => (
  <div className='mc-mb-4'>
    <p className='d-none d-md-block mc-text-h6 mc-mb-1'>{title}</p>
    <p className='d-block d-md-none mc-text-h7 mc-mb-1'>{title}</p>

    <p className='mc-text-small mc-text-color--medium'>{description}</p>
  </div>
)
